import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const gmailApi = createApi({
  reducerPath: "gmail",
  baseQuery: prepareBaseQuery("/email/gmail/"),
  endpoints: (builder) => ({
    getStatus: builder.query({
      query: () => ({
        url: "status",
        method: "GET",
      }),
    }),
    listMessages: builder.query({
      query: (params = {}) => ({
        url: "messages",
        params,
      }),
    }),
    // A plain thread id, or { threadId, messageId } for a thread that holds
    // only a just saved draft (the server falls back to the draft).
    getThread: builder.query({
      query: (arg) => {
        if (typeof arg === "string") return `threads/${arg}`;
        const messageId = arg?.messageId ?? "";
        return {
          url: `threads/${arg?.threadId ?? ""}`,
          ...(messageId ? { params: { messageId } } : {}),
        };
      },
    }),
    sendMessage: builder.mutation({
      query: ({ to, subject, htmlBody, threadId }) => ({
        url: "send",
        method: "POST",
        body: {
          to,
          subject,
          htmlBody,
          ...(threadId ? { threadId } : {}),
        },
      }),
    }),
  }),
});

export const {
  useGetStatusQuery,
  useListMessagesQuery,
  useLazyListMessagesQuery,
  useGetThreadQuery,
  useSendMessageMutation,
} = gmailApi;

export default gmailApi;
export { gmailApi };
